(function () {
  function formatEstimate(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(amount);
    } catch (e) {
      return currency + ' ' + Math.round(amount);
    }
  }

  function run() {
    var nodes = document.querySelectorAll('.price-currency-estimate[data-inr]');
    if (!nodes.length) return;

    fetch('https://open.er-api.com/v6/latest/INR')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || !data.rates) return;
        nodes.forEach(function (node) {
          var inr = parseFloat(node.getAttribute('data-inr'));
          var cur = node.getAttribute('data-currency') || 'USD';
          var rate = data.rates[cur];
          if (!inr || !rate) return;
          var converted = inr * rate;
          var small = node.querySelector('.price-currency-estimate__text');
          if (small) {
            small.textContent = '≈ ' + formatEstimate(converted, cur) + ' (est.)';
          }
        });
      })
      .catch(function () { /* silently skip if the estimate can't be fetched */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
